import React from 'react';
import './SalesForm2.scss';
import SalesQuantityMulti from "../../components/SalesQuantityMulti";
import Dealer from "../../components/Dealer";
import Port from "../../components/Port";
import DateSold from "../../components/DateSold";

const SalesForm2 = (props) => {
      if (props.currentStep !== 2) {
            return null;
      }
      console.group('SalesForm2');
      console.log(props);
      console.groupEnd();
      return (
          <div className="SalesForm2" data-testid="SalesForm2">
                <SalesQuantityMulti
                    sales={props.sales}
                    handleSoldChange={props.handleMultiSoldChange}
                    helpText={props.helpText}
                />
                <Dealer
                    dealer_permit_number={props.dealer_permit_number}
                    dealer_name={props.dealer_name}
                    helpText={props.helpText}
                    changeHandler={props.dealerChangeHandler}
                    handleDealerPreferenceChange={props.handleDealerPreferenceChange}
                />
                <Port
                    helpText={props.helpText}
                    changeHandler={props.portChangeHandler}
                    handlePortPreferenceChange={props.handlePortPreferenceChange}
                    port_id={props.port_id}
                    port_state={props.port_state}
                    port_name={props.port_name}
                    port_city={props.port_city}
                />
                <DateSold
                    DateSoldNowHandler={props.DateSoldNowHandler}
                    display_date_sold={props.display_date_sold}
                    dateSoldHandler={props.dateSoldHandler}
                    helpText={props.helpText}
                />
          </div>
      );
}



export default SalesForm2;
